module.exports = __webpack_public_path__ + "h5/img/vip5.020adab7.png";